import React, { useContext, useEffect, useState } from 'react'
import BabyIcon from '../../assets/baby.svg'
import { useNavigate } from 'react-router-dom';
import { FeedingChart } from '../Charts/FeedingChart';
import { BiomarkersSection } from './PatientCardComponents/BiomarkersSection';
import { FeedingDetailsSection } from './PatientCardComponents/FeedingDetailsSection';
import { BiomarkersChart } from '../Charts/BiomarkersChart';
import { SessionSelectorSection } from './PatientCardComponents/SessionSelectorSection';
import UpdateFavoritePatient from '../../data_layer/repositories/Patients/UpdateFavoritePatient';
import { useGetFeedingDetails } from "../CustomHooks/useGetFeedingDetails";
import { useGetFlags } from "../CustomHooks/useGetFlags";
import { useGetBiomarkersListByPatientId } from "../CustomHooks/useGetBiomarkersListByPatientId";
import { PatientContext } from '../../data_layer/context/Patient/PatientContext';
import { TooltipWrapper } from '../Tooltips/TooltipWrapper';
import { LargeCardSize, MediumCardSize, SmallCardSize } from '../../utilities/Constants';



export const PatientCardV2 = ({ 
    patient, 
    user, 
    favoritePatients, 
    refreshFavorites 
}) => {

    const navigate = useNavigate();

    const [cardSize, setCardSize] = useState(4);
    
    const [currentTimestamp, setCurrentTimestamp] = useState();

    const [isFavorite, setIsFavorite] = useState(false);

    const { feeding } = useGetFeedingDetails(currentTimestamp);

    const { flags } = useGetFlags(currentTimestamp);

    const { biomarkers, getBiomarkers } = useGetBiomarkersListByPatientId(patient.patient_id);

    const { 
        initPatientList, 
        setCurrentFeeding,
        showDetails,
        showGraph
    } = useContext(PatientContext);

    const onCardClick = (timestamp) => {
        
        initPatientList(patient);
        setCurrentFeeding(patient.patient_id, timestamp);
        navigate(`patients/${patient.patient_id}`, {
            state: { 
                patient
            }
        });
    }

    const handleSavePatient = () => {
        setIsFavorite(!isFavorite);
        UpdateFavoritePatient(patient.patient_id, user.user_id, refreshFavorites);
    }


    useEffect(() => {
        getBiomarkers();
    }, [patient]);

    useEffect(() => {
        setIsFavorite(favoritePatients.find((fp) => fp.patient_id === patient.patient_id));
    }, [favoritePatients]);


    useEffect(() => {
        if (showGraph) {
            setCardSize(LargeCardSize);
        }
        else if (showDetails && !showGraph) {
            setCardSize(MediumCardSize);
        }
        else {
            setCardSize(SmallCardSize)
        }

        setCurrentTimestamp(patient?.feedings[0].timestamp)

    }, [showDetails, showGraph]);

    function onDateClick(timestamp) {

        setCurrentTimestamp(timestamp);

        if (!showDetails && !showGraph)
            onCardClick(timestamp);
            
    }


    return (
        <div className={`col-md-${cardSize} mb-2 px-1`}>
            <div className="w-100 rounded-2 bg-white">
                <div className="row">
                    <div className={`py-1 border-end ${showGraph ? 'col-lg-5' : 'col-lg-11'}`}>
                        {/*<!-- Header -->*/}
                        <div className="mt-1 d-flex w-100">
                            <div className="px-2 pb-0 d-flex align-items-center w-100">
                                <div className="d-flex align-items-center gap-2 pe-3">
                                    <img src={BabyIcon} alt="patient" className='m-1' width={25} height={25} />
                                    <p className="fw-bold m-0">ID: {patient?.ehr_patient_ref}</p>
                                </div>
                                <div className="ms-auto" style={{ minWidth: 0, overflow: 'hidden' }}>
                                    <p className="text-sm mb-0 text-truncate">{patient?.name}
                                        <span className="mx-1">|</span> {patient?.gestational_age} GA
                                        <span className="mx-1">|</span> {`${patient?.birth_weight} ${patient?.weight_uom} birth wt`}
                                        <span className="mx-1">|</span> { patient?.feedings?.length } {`Session${patient?.feedings?.length > 1 ? 's' : ''}`}
                                    </p>
                                </div>


                            </div>
                            {/* <div className="d-flex pe-1 align-items-center  ms-auto date-selector" onClick={onCardClick}>
                                <p className="fw-semibold mb-2 text-xs">View details</p>
                                <i className='bx bx-right-arrow-alt text-2xl mb-2 ms-1'></i>
                            </div> */}
                        </div>
                        {/*<!-- Sub Header -->*/}

                        <SessionSelectorSection
                            currentTimestamp={currentTimestamp}
                            feedings={patient?.feedings}
                            onDateClick={onDateClick}
                            isSmallCard={cardSize === SmallCardSize} />


                        {/*<!-- Content -->*/}
                        {showDetails &&
                            <div className="d-flex">
                                <div className="px-3 pt-2 w-100 d-flex align-items-stretch">

                                    <FeedingDetailsSection feeding={feeding} />
                                    <BiomarkersSection biomarkers={biomarkers?.feedings?.find((feed) => feed.timestamp === currentTimestamp)?.biomarkers?.slice(0,6)} />

                                </div>
                            </div>
                        }
                    </div>
                    <div className={`d-flex justify-content-center align-items-center ${showGraph ? 'col-lg-7' : 'col-lg-1'}`}>
                        
                            {showGraph && <>
                                <div className="border-end d-flex flex-column pt-2 px-4 chart-mindex-box">
                                    <p className="fw-semibold mb-2 text-xs">Maturation Index | <span className="text-muted">Weight (g)</span></p>
                                    <BiomarkersChart feedings={biomarkers?.feedings} conceptionDate={patient?.date_of_conception} />
                                </div>
                                <div className="d-flex mx-auto flex-column pt-2 px-4 flex-1">
                                    <div className="d-flex align-items-center">
                                        {/* <p className="fw-semibold mb-2 text-xs">Oral Cavity Pressure (mmHg) | <span className="text-muted">Temperature (c)</span></p> */}
                                        <div className="d-flex gap-3 align-items-center">
                                            <p className="fw-semibold mb-2 text-xs"><i className='bx bxs-circle text-pressure'></i> Suck-Swallow (suck ▲ swallow ▼)</p>

                                            <p className="fw-semibold mb-2 text-xs"><i className='bx bxs-circle text-breathing'></i> Breathing (in ▼ out ▲)</p>
                                        </div>
                                    </div>
                                    <FeedingChart feeding={feeding} flags={flags} isLightGraph={true} />
                                </div></>
                            }
                            <div className="d-flex flex-column gap-2 align-content-start">

                                <TooltipWrapper content="See details">
                                    <i className={`bx bx-search-alt-2 text-3xl card-icon`}
                                        onClick={() => onCardClick(currentTimestamp)}></i>
                                </TooltipWrapper>

                                <TooltipWrapper content={isFavorite ? "Remove patient" : "Save patient"}>
                                    <i className={`bx ${isFavorite ? 'bxs-bookmark' : 'bx-bookmark'} text-3xl card-icon`}
                                        onClick={handleSavePatient}></i>
                                </TooltipWrapper>

                                {cardSize !== 4 &&
                                    <>
                                    <TooltipWrapper content={flags?.length > 0 ? `Contains ${flags?.length} flag${flags?.length > 1 ? 's' : ''}` : "Flags"}>
                                        <div className='position-relative'>
                                            
                                            <i className={`bx bx-flag text-3xl ${flags?.length > 0 ? 'text-deep-purple' : 'text-light-purple'}`}
                                                data-tooltip-id='flags-tooltip'></i>
                                            {flags?.length > 0 &&
                                                <div className={`dot-number text-white d-flex align-items-center justify-content-center rounded-circle position-absolute text-xxs`}>
                                                    {flags?.length}
                                                </div>
                                            }
                                        </div>
                                        </TooltipWrapper>

                                        <TooltipWrapper content={feeding?.note || "Comment"}>
                                        <div className='position-relative'>
                                            <i className={`bx bx-comment text-3xl ${feeding?.note ? 'text-deep-purple' : 'text-light-purple'}`}
                                                data-tooltip-id='comment-tooltip'></i>
                                            {feeding?.note &&
                                                <div className={`dot-number text-white d-flex align-items-center justify-content-center rounded-circle position-absolute text-xxs`}>
                                                    1
                                                </div>
                                            }
                                        </div>
                                        </TooltipWrapper>
                                    </>
                                }

                            </div>
                        
                    </div>
                </div>
            </div>
        </div>
    )
}
